import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import { holidayListSchema, type Holiday, type HolidayPayload } from '../types/holiday.types';

export const holidayQueryKeys = {
  all: () => ['holidays'] as const,
  lists: () => [...holidayQueryKeys.all(), 'list'] as const,
  list: (params: { year: number }) => [...holidayQueryKeys.lists(), params] as const,
};

export const holidaysQueryOptions = (year: number) =>
  queryOptions({
    queryKey: holidayQueryKeys.list({ year }),
    queryFn: async (): Promise<Holiday[]> => {
      const res = await apiClient.get(API.holiday.list, { params: { year } });
      return holidayListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createHoliday(payload: HolidayPayload): Promise<void> {
  await apiClient.post(API.holiday.create, payload);
}

export async function updateHoliday(id: number, payload: HolidayPayload): Promise<void> {
  await apiClient.patch(API.holiday.update(id), payload);
}

export async function deleteHoliday(id: number): Promise<void> {
  await apiClient.delete(API.holiday.delete(id));
}
